const Shimmer = () =>{
    return (
        <div className="flex flex-wrap justify-center">
            <div className="m-4 p-4 w-[17rem] h-96 rounded-lg bg-gray-300"></div>
            <div className="m-4 p-4 w-[17rem] h-96 rounded-lg bg-gray-300"></div>
            <div className="m-4 p-4 w-[17rem] h-96 rounded-lg bg-gray-300"></div>
            <div className="m-4 p-4 w-[17rem] h-96 rounded-lg bg-gray-300"></div>
            <div className="m-4 p-4 w-[17rem] h-96 rounded-lg bg-gray-300"></div>
            <div className="m-4 p-4 w-[17rem] h-96 rounded-lg bg-gray-300"></div>
            <div className="m-4 p-4 w-[17rem] h-96 rounded-lg bg-gray-300"></div>
            <div className="m-4 p-4 w-[17rem] h-96 rounded-lg bg-gray-300"></div>
            {/* <div className="m-4 p-4 w-[17rem] h-96 rounded-lg bg-gray-100"></div> */}
        </div>
    )
}

export default Shimmer;